import { cartConfig } from '../../../../config';
import { http } from '../../../../api/axios';
import { AccountOut } from '../../../../store/api';

export const fetchAccounts = (): Promise<AccountOut[]> => {
    return http.get(cartConfig().endpointAccounts).then(response => {
        return response.data;
    });
};
